﻿$.fn.dxCtrlEmailPrevisualisationAcid = function custom_dxCtrlEmailPrevisualisationAcid(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlemailprevisualisationacid dx-ctrl");
        this.createInstance(new cdxCtrlEmailPrevisualisationAcid(this, option));
    }
    return this;
}

window.cdxCtrlEmailPrevisualisationAcid = function (container, option) {
    var Me = this;
    //var keyCnx = "Basic " + $.base64.encode("f173cfcc61e48cbb1f8b31b911bc35287c17e06c:nyonsais19;")
    var keyCnx = "Basic " + $.base64.encode("a5048ff7dc877f376a8a1f311fbf6318599e3866:Nyonsais369!")
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.bddCtrl.utiCourantParaJson.previewEmail == "undefined") {
        option.bddCtrl.utiCourantParaJson.previewEmail = { zoom: 5 }
    }

    var jauge = null
    var dxScrollLst = null
    var lstVue = []
    var lstLstAcidPreview = []
    var cropped = false
    var $DivBtExeNewTest = null
    //var firstLoad = true
    function mConstruit() {
        container.empty()

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()

        ////option.onNewTest
        //option.idTestAcid
        //option.dateTestAcid
        //test1: "c2TkMK2pIxM75cBWoROysnfHvL2UHsEdjs0iplRtowpL6"
        //test2: "ckqWGZ5GfOyceQo58h4tl5B0KDVWdcUQXy6KSJfq1Hm0U"
        //test3: "RpT0YdGAbgkxSlmKoA0s5pw76FhfcNYEUL5ZjPE6U9QRT"

        //if (firstLoad) option.idTestAcid = "jhjhkjhkhj"
        //firstLoad = false
        ////idTest = "c2TkMK2pIxM75cBWoROysnfHvL2UHsEdjs0iplRtowpL6"
        ////option.idTestAcid = "Ydl0YkpHpkMoj3pjpG1Sg8tdaAj4bWFAY4xlR6JzLz5vv"
        ////option.dateTestAcid = new Date()
        if (option.idTestAcid.length == 0) {
            $DivBtExeNewTest = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'></div>").appendTo(container)
            var $DivBtExeNewTestInterne = $("<div style='text-align:center;'></div>").appendTo($DivBtExeNewTest)
            $("<div style='font-size:italic;padding-bottom:10px;'><b>Visualisez la mise en page de votre email</b><br/>dans plus de 100 outils de réception de mails<br/>parmi les plus populaires (outlook, gmail, yahoo, ios, free...)</div>").appendTo($DivBtExeNewTestInterne)
            $("<div style='display:inline-block;'/>").appendTo($DivBtExeNewTestInterne).dxCtrlButton({
                text: "Générer un nouveau test",
                onClick: function (e) {
                    mGenereNewTest(e.component.element())
                }
            })
            if (option.bddCtrl.objCptCli.objetMetier.mGetNbTestEmailDispo() == 0) {
                $("<div style='padding-top:10px;'>Vous n'avez aucun crédit de test emails</div>").appendTo($DivBtExeNewTestInterne)
                $A = $("<a href='javascript:void(0)'>Acheter des crédits de test email</a>").appendTo($DivBtExeNewTestInterne)
                $A.on("click", function (e) {
                    $("<div/>").appendTo("body").dxCtrlAchatPopup({
                        bddCtrl: option.bddCtrl,
                        typeProduit: "credit_test_email",
                        nb: 10,
                        onPaiement: function () {
                            jaugeDemarrage.mShow()
                            option.bddCtrl.mReloadTable("credit_test_email", function () {
                                mConstruit()
                                jaugeDemarrage.mHide()
                            })
                        }
                    })
                })
            } else {
                $("<div style='padding:10px;'>Vous disposez de " + option.bddCtrl.objCptCli.objetMetier.mGetNbTestEmailDispo() + " crédit de test email</div>").appendTo($DivBtExeNewTestInterne)
            }
            jauge.mHide()
        } else {
            mVerifExistTest(option.idTestAcid, function (exist) {
                if (exist) { mRempliWithTest(option.idTestAcid) }
                else {
                    option.idTestAcid = ""
                    option.dateTestAcid = ""
                    option.onNewTest(option.idTestAcid)
                    mConstruit()
                }
            })
        }

    }

    function mGenereNewTest(target, funcKo) {
        if (option.bddCtrl.objCptCli.objetMetier.mGetNbTestEmailDispo() <= 0) {
            //pas de crédit test email
            option.bddCtrl.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Vous ne disposez pas<br/>de crédit de test email.<br/>Accédez à votre compte<br/>pour acheter des tests emails.", "Acheter des tests emails", 3, function () {
                $("<div/>").appendTo("body").dxCtrlAchatPopup({
                    bddCtrl: option.bddCtrl,
                    typeProduit: "credit_test_email",
                    nb: 10,
                    onPaiement: function () {
                        jaugeDemarrage.mShow()
                        option.bddCtrl.mReloadTable("credit_test_email", function () {
                            mConstruit()
                            jaugeDemarrage.mHide()
                        })
                    }
                })
            })
            return
        } else {
            jauge.mShow()
            option.onDemandeUrl(function (url) {
                var html = ""
                if (typeof option.onDemandeHtml != 'undefined') { html = option.onDemandeHtml() }
                else { html = option.html }
                mCreateTest(option.objet, html, url, function (idTest) {
                    if (idTest.length > 0) {
                        option.idTestAcid = idTest
                        option.dateTestAcid = new Date()
                        option.onNewTest(option.idTestAcid)
                        mRempliWithTest(option.idTestAcid)
                        if ($DivBtExeNewTest) $DivBtExeNewTest.remove()
                    } else {
                        //on eu une erreur
                        mNotify("Impossible de créer le test", "warning", 6000)
                        jauge.mHide()
                        if (typeof funcKo != 'undefined') funcKo()
                    }
                })
            })
        }
    }

    var nbBoucle = 0
    function mRempliWithTest(idTest) {
        mGetTest(idTest, function (data) {

            var idxTot = 0
            var idxOut = 0
            for (var prop in data) {
                idxTot += 1
                if (data[prop].status != "Complete") idxOut += 1
            }
            var totOk = 100
            if (idxOut > 0) totOk = (idxTot - idxOut) / idxTot * 100

            jauge.mAvance("Génération test email", totOk, 100)
            if (totOk < 90 && nbBoucle < 8) {
                nbBoucle += 1
                //on a moins de 80% des visu généré, on attend 5 secondes
                window.setTimeout(function () { mRempliWithTest(idTest) }, 4000)
            } else {
                nbBoucle = 0
                lstLstAcidPreview = []
                lstVue = []
                //mCreateTest(option.objet, option.html, function (data) {
                //mGetTest(data.id, function (data) {
                for (var prop in data) lstVue.push(data[prop])
                lstVue = lstVue.sort(function (o1, o2) {
                    return o1.category.localeCompare(o2.category) || o1.client.localeCompare(o2.client) || o1.os.localeCompare(o2.os)
                })
                lstVue.forEach(function (o) { o.checked = true; o.lstChk = [] })
                mInitLstVueChk()
                var selectedIds = [0]

                container.css("position", "relative")

                //if (typeof option.bddCtrl.utiCourantParaJson.previewEmail == "undefined") {
                //    option.bddCtrl.utiCourantParaJson.previewEmail = { zoom: 5 }
                //    option.bddCtrl.mSaveParaJsonUtilisateur();
                //}

                var dxScrollImg = $("<div style='position:absolute;top:0;right:0;z-index:1;width:calc(100% - 275px);border:" + theme.border + ";'/>").appendTo(container).dxScrollView({
                    useNative: true
                }).dxScrollView("instance")
                $("<div style='height:100%;'/>").appendTo(dxScrollImg.content()).dxCtrlAccordion({
                    dataSource: [{ id: 0, text: "Application", category: "Application", icon: "fas fa-desktop" }, { id: 1, text: "Mobile", category: "Mobile", icon: "fas fa-mobile-screen-button" }, { id: 2, text: "Web", category: "Web", icon: "fas fa-globe" }],
                    multiple: true,
                    stickyTitle: true,
                    selectedIds: selectedIds,
                    itemClosed: function (itemData) { selectedIds.splice(selectedIds.indexOf(itemData.id), 1) },
                    itemOpened: function (itemData) { selectedIds.push(itemData.id) },
                    itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                        var $Table = $("<table style='margin-left:80px;width:95%;position:absolute;top:7px;'/>").appendTo(itemElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:50px'><i class='" + itemData.icon + "' style='font-size:30px;'></i></td>").appendTo($Tr)
                        var $Td = $("<td style='font-size:140%'>" + itemData.text + "</td>").appendTo($Tr)
                    },
                    itemTemplate: function (itemData, itemIndex, itemElement) {
                        itemElement.empty()
                        var lst = lstVue.filter(function (o) { return o.category == itemData.category })
                        lstLstAcidPreview.push($("<div style='margin:5px;'/>").appendTo(itemElement).dxCtrlEmailPrevisualisationAcidClientLst({
                            bddCtrl: option.bddCtrl,
                            data: lst,
                            zoom: option.bddCtrl.utiCourantParaJson.previewEmail.zoom,
                            onReloadImage: function (idImg, funcFin) { mReloadImage(idImg, funcFin); },
                            cropped: cropped
                        }).dxCtrlEmailPrevisualisationAcidClientLst("instance"))
                    }
                })

                var $DivMenu = $("<div style='position:absolute;top:0;left:0;width:265px;height:100%;border:" + theme.border + ";padding:5px 5px 0 5px;'/>").appendTo(container)
                var $DivEntete = $("<div/>").appendTo($DivMenu)
                var $TableEntete = $("<table/>").appendTo($DivEntete)
                var $Tr = $("<tr/>").appendTo($TableEntete)
                var $TdTitle = $("<td style='width:100%;font-size:130%;' colspan='2'><span style='opacity:0.5;'>Test </span><span title='" + ((option.dateTestAcid != "") ? option.dateTestAcid.toDDMMAA() : "") + "'>" + ((option.dateTestAcid != "") ? option.dateTestAcid.toDateIlya() : "") + "</span></td>").appendTo($Tr)
                if (option.dateTestAcid != "" && option.dateDocument != "") {
                    if (option.dateTestAcid < option.dateDocument) {
                        $("<div style='color:red;padding:10px;' class='blinkscalealways'>Ce test est antérieure à vos dernières modifications</div>").appendTo($TdTitle)
                    }
                }
                var $Tr = $("<tr/>").appendTo($TableEntete)
                var $TdNew = $("<td style='width:50px;min-width:50px;'/>").appendTo($Tr)
                var $TdZoom = $("<td style='width:100%;'/>").appendTo($Tr)
                var dxSlider = $("<div/>").appendTo($TdZoom).dxSlider({
                    min: 2,
                    max: 20,
                    value: option.bddCtrl.utiCourantParaJson.previewEmail.zoom,
                    hint:"Ajouter le zoom des vignettes",
                    onValueChanged: function (e) {
                        lstLstAcidPreview.forEach(function (dxLst) {
                            if (dxLst.element().closest("body").length >= 1) dxLst.mChangeZoom(e.value)
                        })
                        option.bddCtrl.utiCourantParaJson.previewEmail.zoom = e.value
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                    },
                    onContentReady: function (e) {
                        window.setTimeout(function () {
                            dxScrollLst.element().css({
                                "height": "calc(100% - " + $TableEntete.innerHeight() + "px)",
                                top: $TableEntete.innerHeight() + "px"
                            })
                        }, 100)
                    }
                }).dxSlider("instance")
                $("<div style=''/>").appendTo($TdNew).dxCtrlButton({
                    icon: 'fas fa-delete-left',
                    txtTooltip: "Supprimez le test pour pouvoir créer un nouveau test",
                    width: HeightButton,
                    height: HeightButton,
                    onClick: function (e) {
                        jauge.mShow()
                        mDelTest(option.idTestAcid, function (deleteOk) {
                            option.idTestAcid = ""
                            option.dateTestAcid = ""
                            option.onNewTest(option.idTestAcid)
                            mConstruit()
                            mNotify("Le test a été supprimé", "success", 3000)
                        })
                    }
                }).dxCtrlButton("instance");

                $("<div/>").appendTo($DivEntete).dxCtrlCheckBox({
                    text: "Réduire",
                    value: cropped,
                    hint: "Réduire la taille de vignettes",
                    onValueChanged: function (e) {
                        cropped = e.value
                        lstLstAcidPreview.forEach(function (dxLst) {
                            if (dxLst.element().closest("body").length >= 1) dxLst.mChangeCrop(cropped)
                        })
                    }
                })

                dxScrollLst = $("<div style='height:calc(100% - " + $DivEntete.innerHeight() + "px)'/>").appendTo($DivMenu).dxScrollView({}).dxScrollView("instance")
                mConstruitList()

                var dxBtHide = $("<div style='position:absolute;z-index:1;left:280px;top:7px;'/>").appendTo(container).dxCtrlButton({
                    icon: 'fas fa-arrow-left',
                    txtTooltip: "Cacher la liste",
                    width: HeightButton - 15,
                    height: HeightButton - 15,
                    onClick: function (e) {
                        $DivMenu.fadeOut(400)
                        dxScrollImg.element().animate({ "width": "100%" }, 400)
                        dxBtShow.element().show(400)
                        dxBtHide.element().hide()
                        dxBtNewTest.element().css("left", "45px")
                    }
                }).dxCtrlButton("instance");
                var dxBtShow = $("<div style='position:absolute;z-index:1;left:5px;top:7px;display:none;'/>").appendTo(container).dxCtrlButton({
                    icon: 'fas fa-arrow-right',
                    txtTooltip: "Montrer la liste",
                    width: HeightButton - 15,
                    height: HeightButton - 15,
                    onClick: function (e) {
                        $DivMenu.fadeIn(400)
                        var newWidth = dxScrollImg.element().innerWidth() - 275
                        dxScrollImg.element().animate({ "width": newWidth + "px" }, 400, function () { dxScrollImg.element().css({ "width": "calc(100% - 275px)" }) })
                        dxBtShow.element().hide()
                        dxBtHide.element().show(400)
                        dxBtNewTest.element().css("left", "325px")
                    }
                }).dxCtrlButton("instance");
                var dxBtNewTest = $("<div style='position:absolute;z-index:1;left:325px;top:7px;'/>").appendTo(container).dxCtrlButton({
                    icon: 'fas fa-certificate',
                    txtTooltip: "Générer un nouveau test",
                    width: HeightButton - 15,
                    height: HeightButton - 15,
                    onClick: function (e) {
                        mDelTest(option.idTestAcid, function (deleteOk) {
                            if (option.bddCtrl.objCptCli.objetMetier.mGetNbTestEmailDispo() > 0) {
                                //on a encore des tests
                                jauge.mShow()
                                option.idTestAcid = ""
                                option.dateTestAcid = ""
                                option.onNewTest(option.idTestAcid)
                                container.empty()
                                jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
                                jauge.mShow()
                                mGenereNewTest(e.component.element(), function () { mConstruit() })
                            } else {
                                //on a plus de test, l'appel de la fonction va afficher le signalement de plus de test
                                mGenereNewTest(e.component.element())
                            }
                        })
                    }
                }).dxCtrlButton("instance");

                window.setTimeout(function () {
                    dxScrollLst.element().css("height", "calc(100% - " + $DivEntete.innerHeight() + "px)")
                    jauge.mHide()
                }, 500);
            }
            //})
        })
    }

    function mConstruitList() {
        mSaveHistoLstVue()
        dxScrollLst.content().css("height", dxScrollLst.content().innerHeight() + 'px')
        dxScrollLst.content().empty()
        var category = null
        var client = null
        var os = null
        var inCheckedInCode = false
        lstVue.forEach(function (item) {
            if (category != item.category) {
                category = item.category
                var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(dxScrollLst.content())
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='font-variant:small-caps;font-weight:bold;width:100%;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;font-size:200%;'>" + item.category + "</td>").appendTo($Tr)
            }
            if (client != item.client) {
                client = item.client
                var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(dxScrollLst.content())
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:30px;padding:5px 5px 5px 5px;'/>").appendTo($Tr)
                item.lstChk.push($("<div/>").appendTo($Td).dxCtrlCheckBox({
                    text: "",
                    value: item.checked,
                    onValueChanged: function (e) {
                        if (inCheckedInCode) return
                        inCheckedInCode = true
                        lstVue.filter(function (o) { return o.category == item.category && o.client == item.client }).forEach(function (o) {
                            o.checked = e.value
                            o.lstChk.forEach(function (chk) { chk.option("value", e.value) })
                            if (typeof o.container != 'undefined') {
                                if (e.value) { o.container.slideDown(400, "swing", function () { o.container.css("display", "inline-block") }) }
                                else { o.container.slideUp() }
                            }
                        })
                        lstLstAcidPreview.forEach(function (dxLst) {
                            if (dxLst.element().closest("body").length >= 1) dxLst.mShowHideNoDataText()
                        })
                        mSaveHistoLstVue()
                        inCheckedInCode = false
                    }
                }).dxCtrlCheckBox("instance"))
                var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;font-size:150%;'>" + item.client + "</td>").appendTo($Tr)
            }
            if (os != item.os) {
                os = item.os
                if (lstVue.filter(function (o) { return o.category == item.category && o.client == item.client && o.os == item.os }).length > 1) {
                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(dxScrollLst.content())
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:60px;padding:5px 5px 5px 30px;'/>").appendTo($Tr)
                    item.lstChk.push($("<div/>").appendTo($Td).dxCtrlCheckBox({
                        text: "",
                        value: item.checked,
                        onValueChanged: function (e) {
                            if (inCheckedInCode) return
                            inCheckedInCode = true
                            lstVue.filter(function (o) { return o.category == item.category && o.client == item.client && o.os == item.os }).forEach(function (o) {
                                o.checked = e.value
                                o.lstChk.forEach(function (chk) { chk.option("value", e.value) })
                                if (typeof o.container != 'undefined') {
                                    if (e.value) { o.container.slideDown(400, "swing", function () { o.container.css("display", "inline-block") }) }
                                    else { o.container.slideUp() }
                                }
                            })
                            lstLstAcidPreview.forEach(function (dxLst) {
                                if (dxLst.element().closest("body").length >= 1) dxLst.mShowHideNoDataText()
                            })
                            mSaveHistoLstVue()
                            inCheckedInCode = false
                        }
                    }).dxCtrlCheckBox("instance"))
                    var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;font-size:120%;'>" + item.os + "</td>").appendTo($Tr)

                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(dxScrollLst.content())
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:90px;padding:5px 5px 5px 60px;'/>").appendTo($Tr)
                    item.lstChk.push($("<div/>").appendTo($Td).dxCtrlCheckBox({
                        text: "",
                        value: item.checked,
                        onValueChanged: function (e) {
                            if (inCheckedInCode) return
                            inCheckedInCode = true
                            item.checked = e.value
                            item.lstChk.forEach(function (chk) { chk.option("value", e.value) })
                            if (typeof item.container != 'undefined') {
                                if (e.value) { item.container.slideDown(400, "swing", function () { item.container.css("display", "inline-block") }) }
                                else { item.container.slideUp() }
                            }
                            lstLstAcidPreview.forEach(function (dxLst) {
                                if (dxLst.element().closest("body").length >= 1) dxLst.mShowHideNoDataText()
                            })
                            mSaveHistoLstVue()
                            inCheckedInCode = false
                        }
                    }).dxCtrlCheckBox("instance"))
                    var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;font-style:italic;font-size:80%;' title='" + item.display_name + "'>" + item.display_name + "</td>").appendTo($Tr)
                } else {
                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(dxScrollLst.content())
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:60px;padding:5px 5px 5px 30px;'/>").appendTo($Tr)
                    item.lstChk.push($("<div/>").appendTo($Td).dxCtrlCheckBox({
                        text: "",
                        value: item.checked,
                        onValueChanged: function (e) {
                            if (inCheckedInCode) return
                            inCheckedInCode = true
                            lstVue.filter(function (o) { return o.category == item.category && o.client == item.client && o.os == item.os }).forEach(function (o) {
                                o.checked = e.value
                                o.lstChk.forEach(function (chk) { chk.option("value", e.value) })
                                if (typeof o.container != 'undefined') {
                                    if (e.value) { o.container.slideDown(400, "swing", function () { o.container.css("display", "inline-block") }) }
                                    else { o.container.slideUp() }
                                }
                            })
                            lstLstAcidPreview.forEach(function (dxLst) {
                                if (dxLst.element().closest("body").length >= 1) dxLst.mShowHideNoDataText()
                            })
                            mSaveHistoLstVue()
                            inCheckedInCode = false
                        }
                    }).dxCtrlCheckBox("instance"))
                    var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;font-size:120%;font-style:italic;font-size:80%;' title='" + item.os + "-" + item.display_name + "'>" + item.os + "<br/>" + item.display_name + "</td>").appendTo($Tr)
                }
            } else {
                var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(dxScrollLst.content())
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:90px;padding:5px 5px 5px 60px;'/>").appendTo($Tr)
                item.lstChk.push($("<div/>").appendTo($Td).dxCtrlCheckBox({
                    text: "",
                    value: item.checked,
                    onValueChanged: function (e) {
                        if (inCheckedInCode) return
                        inCheckedInCode = true
                        item.checked = e.value
                        item.lstChk.forEach(function (chk) { chk.option("value", item.value) })
                        if (typeof item.container != 'undefined') {
                            if (e.value) { item.container.slideDown(400, "swing", function () { item.container.css("display", "inline-block") }) }
                            else { item.container.slideUp() }
                        }
                        lstLstAcidPreview.forEach(function (dxLst) {
                            if (dxLst.element().closest("body").length >= 1) dxLst.mShowHideNoDataText()
                        })
                        mSaveHistoLstVue()
                        inCheckedInCode = false
                    }
                }).dxCtrlCheckBox("instance"))
                var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;font-style:italic;font-size:80%;' title='" + item.display_name + "'>" + item.display_name + "</td>").appendTo($Tr)
            }
        })
        dxScrollLst.content().css("height", '')
    }

    function mInitLstVueChk() {
        if (typeof option.bddCtrl.utiCourantParaJson.previewEmail.lstVueChk == 'undefined') mSaveHistoLstVue()
        lstVue.forEach(function (item) {
            if (typeof option.bddCtrl.utiCourantParaJson.previewEmail.lstVueChk[item.id] != 'undefined') item.checked = option.bddCtrl.utiCourantParaJson.previewEmail.lstVueChk[item.id]
        })
    }

    function mSaveHistoLstVue() {
        var lstVueChk = {}
        lstVue.forEach(function (item) { lstVueChk[item.id] = item.checked })
        option.bddCtrl.utiCourantParaJson.previewEmail.lstVueChk = lstVueChk
        option.bddCtrl.mSaveParaJsonUtilisateur();
    }

    function mReloadImage(idImage, funcFin) {
        mGetTest(option.idTestAcid, function (data) {
            var newImage = data[idImage]
            var oldImg = lstVue.filter(function (item) { return item.id == newImage.id })[0]
            var idx = lstVue.indexOf(oldImg)
            if (typeof data[idImage] != 'undefined') {
                newImage.container = oldImg.container
                newImage.checked = oldImg.checked
                newImage.dxScrollImg = oldImg.dxScrollImg
                newImage.lstChk = oldImg.lstChk
                lstVue[idx] = newImage
            }
            funcFin(lstVue[idx])
        })
    }

    function mGetTest(id, funcFin) {
        console.log("API ACID:results")
        $.ajax({
            type: 'GET',
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": keyCnx,
            },
            url: "https://api.emailonacid.com/v5/email/tests/" + id + "/results",
            Accept: "application/json",
            "Content-Type": "application/json",
            success: function (data, status, xhr) {
                funcFin(data)
            },
            complete: function (xhr, status) {
            },
            error: function (xhr, status, error) {
                mTraiteMessageJs("erreurjs", "Erreur API acidmail" + xhr.responseText + "/n" + mGetStackTrace(), document.URLRacine, 0)
                funcFin([])
            }
        })
    }

    function mCreateTest(objet, html, urlHtml, funcOk) {
        console.log("API ACID:create")
        if (objet == "") objet = "(aucun sujet)"
        objet += " " + (new Date()).getTime()
        jauge.option("message", "Génération test email")
        var data = ""
        if (parametre.isLocalhost) {
            data = JSON.stringify({
                "subject": objet,
                "html": html
            })
        } else {
            data = JSON.stringify({
                "subject": objet,
                "url": encodeURI(urlHtml + "acid")
            })
        }
        $.ajax({
            type: 'POST',
            url: "https://api.emailonacid.com/v5/email/tests",
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": keyCnx,
            },
            data: data,
            success: function (data, status, xhr) {
                option.bddCtrl.objCptCli.objetMetier.mUseTestEmail(1)
                funcOk(data.id)
            },
            complete: function (xhr, status) {
                //jauge.mHide()
            },
            error: function (xhr, status, error) {
                debugger;
                mTraiteMessageJs("erreurjs", "Erreur API acidmail" + xhr.responseText + "/n" + mGetStackTrace(), document.URLRacine, 0)
                funcOk("")
            }
        })
    }

    function mVerifExistTest(idTest, funcOk) {
        mGetLstTest(function (data) {
            funcOk(data.filter(function (test) { return test.id == idTest }).length > 0)
        })
    }
    function mGetLstTest(funcOk) {
        console.log("API ACID:lsttest")
        $.ajax({
            type: 'GET',
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": keyCnx,
            },
            url: "https://api.emailonacid.com/v5/email/tests",
            Accept: "application/json",
            "Content-Type": "application/json",
            success: function (data, status, xhr) {
                funcOk(data)
            },
            complete: function (xhr, status) {
                //jauge.mHide()
            },
            error: function (xhr, status, error) {
                mTraiteMessageJs("erreurjs", "Erreur API acidmail" + xhr.responseText + "/n" + mGetStackTrace(), document.URLRacine, 0)
                funcOk([])
            }
        })
    }

    function mDelTest(idTest, funcFin) {
        console.log("API ACID:deltest")
        $.ajax({
            type: 'DELETE',
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": keyCnx,
            },
            url: "https://api.emailonacid.com/v5/email/tests/" + idTest,
            Accept: "application/json",
            "Content-Type": "application/json",
            success: function (data, status, xhr) {
                funcFin(true)
            },
            complete: function (xhr, status) {
            },
            error: function (xhr, status, error) {
                funcFin(false)
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}